export async function getFeatureFlags(api) {
    const values = await api.get("/v1/release_toggles/enabled?client_platform=web");
    return values.data.reduce((acc, { is_active_in_web: isWebEnabled, release_toggle_key: name }) => ({
        ...acc,
        [name]: isWebEnabled,
    }), {});
}
